<template>
  <div class="mt-4 mb-6">
    <div class="mb-2">{{ label }}</div>
    <AdminCellTimestampReadable :value="value" />
  </div>
</template>

<script>
import AdminCellTimestampReadable from '@/components/AdminCellTimestampReadable'
export default {
  name: 'AdminFieldTimestampReadable',
  components: { AdminCellTimestampReadable },
  props: {
    value: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: 'Timestamp',
    },
  },
  data() {
    return {}
  },
}
</script>
